export default "__VITE_ASSET__DrmHjslM__"